import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { HomePage } from "./App";
import { AppDetail } from "./pages/AppDetail";

const router = createBrowserRouter([
  { path: "/", element: <HomePage /> },
  { path: "/app/:id", element: <AppDetail /> },
]);

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

(import.meta.hot.data.root ??= createRoot(elem)).render(app);
